<template>
  <div class="vue-loading">
    <div class="widget-content">
      <div class="content d-flex align-items-center">
        <div class="loading-spinner" v-if="progressSpinnerWidth > 0">
          <ProgressSpinner style="width: 30px; height: 30px" stroke-width="8" />
        </div>
        <span class="loading-text" v-if="loadingMessage.length > 0" v-text="loadingMessage"></span>
      </div>
    </div>
  </div>
</template>

<script>
import ProgressSpinner from 'primevue/progressspinner';
export default {
  name: 'vue-loading',
  components: {
    ProgressSpinner,
  },
  props: {
    loadingMessage: {
      type: String,
      default: 'Loading...',
    },
    progressSpinnerWidth: {
      type: Number,
      default: 35,
    },
  },
};
</script>
<style scoped>
.loading-spinner {
  display: inline-block;
  margin-right: 0.5rem;
}
</style>
